import { CapoPlugin } from "D:/W-S Projekte/WS_intern/ws-styleguide/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];